/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteLookMutationVariables = Types.Exact<{
  input: Types.VisionLookStatusUpdateInput;
}>;
export type DeleteLookMutation = {
  __typename?: "Mutation";
  visionLookStatusUpdate?: {
    __typename?: "VisionLookStatusUpdatePayload";
    result: {
      __typename?: "VisionLookStatusUpdateError";
      message: string;
    } | {
      __typename?: "VisionLookStatusUpdateSuccess";
      lookUpdated: boolean;
    };
  } | null;
};
export const DeleteLookDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "deleteLook"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "VisionLookStatusUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionLookStatusUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionLookStatusUpdateSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "lookUpdated"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionLookStatusUpdateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type DeleteLookMutationFn = Apollo.MutationFunction<DeleteLookMutation, DeleteLookMutationVariables>;

/**
 * __useDeleteLookMutation__
 *
 * To run a mutation, you first call `useDeleteLookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLookMutation, { data, loading, error }] = useDeleteLookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLookMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLookMutation, DeleteLookMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<DeleteLookMutation, DeleteLookMutationVariables>(DeleteLookDocument, options);
}
export type DeleteLookMutationHookResult = ReturnType<typeof useDeleteLookMutation>;
export type DeleteLookMutationResult = Apollo.MutationResult<DeleteLookMutation>;
export type DeleteLookMutationOptions = Apollo.BaseMutationOptions<DeleteLookMutation, DeleteLookMutationVariables>;